'use client'

import { History } from 'lucide-react'

import { StoreCategoriesList } from '../StoreCategoriesList'

import { AppLink } from '@/shared/lib/router'
import { Page } from '@/shared/ui/Page'

export function StoreListPage() {
  return (
    <Page className="bg-[#0389D5] bg-[url('/bgs/store-page.svg')]">
      <div className="w-full max-w-2xl flex justify-end">
        <AppLink
          href="/loja/historico"
          className="inline-flex items-center gap-2 rounded-full bg-white/90 px-4 py-2 text-sm font-bold text-primary-dark shadow-sm hover:bg-white"
        >
          <History size={16} />
          Meus resgates
        </AppLink>
      </div>
      <StoreCategoriesList />
    </Page>
  )
}
